// extracted by mini-css-extract-plugin
export default {"flex":"GridBlock_flex__5hG7K"};